export default __webpack_public_path__ + "static/media/pin-a2u-selected.34ad5ae7.svg";